import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";

const DeleteAddressDialog = ({ open, setOpen, handleDelete }) => {
  const handleClose = () => {
    setOpen(false);
  };
  const handleApprove = () => {
    handleDelete();
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Kayıtlı alıcı adresinizi silmek üzeresiniz. Bu işleme devam etmek
          istediğinize emin misiniz?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="iyzi-button-blue" onClick={handleClose}>
          Hayır
        </Button>
        <Button className="iyzi-button-red" onClick={handleApprove} autoFocus>
          Evet
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteAddressDialog;
